import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEventContext } from '../../../context/event/hooks/use-event-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { EventHeroBanner } from '../hero-banner/event-hero-banner';
import { EventDetailsSkeleton } from './subcomponents';
import { EventDetailsSummary } from './subcomponents/summary';
import { defaultEventDetailsProps, eventDetailsPropsValidator } from './types/props';
const b = bemClassBuilder('v-event-details');
export const EventDetails = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText, cdnOptions, config } = props;
    const { event } = useEventContext();
    if (!event) {
        return enableSkeletonLoadingIndicators ? _jsx(EventDetailsSkeleton, { showEventPoster: config.poster.show }) : null;
    }
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx(EventHeroBanner, Object.assign({}, props)), _jsx(EventDetailsSummary, { event: event, cdnOptions: cdnOptions, config: config, displayText: displayText })] })));
});
EventDetails.displayName = 'EventDetails';
/**
 * The **Event Details** component renders the details of an event.
 */
export const EventDetailsComponent = withComponentWrapper(EventDetails, defaultEventDetailsProps, eventDetailsPropsValidator);
